<template>
  <AdminFailureCodes :pk="'SFC-'" :lockedFilters="{ SupplierIdList: [$route.params.supplierId] }" hideFilters />
</template>


<script>
import AdminFailureCodes from "@/views/admin/machines/AdminFailureCodes.vue";

export default {
  name: "ViewSupplierFailureCodeList",
  props: {},
  components: {
    AdminFailureCodes,
  },

  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>